import styled from "styled-components";
import { Layout, Menu } from "antd";

const { Header: AntHeader } = Layout;

export const StyledHeader = styled(AntHeader)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgb(38 127 92);
  padding: 0 24px;
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 16px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RestaurantTitle = styled.h1`
  color: white;
  margin: 0;
  font-size: 1.5rem;
  font-weight: bold;
`;

export const Logo = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
`;

export const StyledMenu = styled(Menu)`
  flex: 1;
  justify-content: flex-end;
  background: transparent;
  border: none;
`;

export const ResponsiveContainer = styled.div`
  @media (max-width: 768px) {
    ${StyledHeader} {
      flex-direction: column;
      padding: 16px;
    }

    ${HeaderContent} {
      margin-bottom: 16px;
    }

    ${StyledMenu} {
      width: 100%;
      justify-content: center;
    }
  }
`;
